import { render } from "./Qoutes.vue?vue&type=template&id=4b87ebd4&scoped=true"
import script from "./Qoutes.vue?vue&type=script&lang=js"
export * from "./Qoutes.vue?vue&type=script&lang=js"

import "./Qoutes.vue?vue&type=style&index=0&id=4b87ebd4&lang=scss&scoped=true"

import exportComponent from "/home/newbuyanyinsuran/public_html/wizards/car.buyanyinsurance.ae/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b87ebd4"]])

export default __exports__